import { render, staticRenderFns } from "./PDF_Comment_2.vue?vue&type=template&id=f0403c22&scoped=true"
import script from "./PDF_Comment_2.vue?vue&type=script&lang=js"
export * from "./PDF_Comment_2.vue?vue&type=script&lang=js"
import style0 from "./PDF_Comment_2.vue?vue&type=style&index=0&id=f0403c22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0403c22",
  null
  
)

export default component.exports